export const state = () => ({
  current: null, list: null, meta: null
});

export const mutations = {
  clear (state) {
    state.current = null;
    state.list = null;
  },
  clearCurrent (state) {
    state.current = null;
  },
  set (state, provider) {
    state.current = provider;
  },
  setList (state, list) {
    state.list = list;
  },
  setListFromProducts (state, products) {
    let providerSet = new Set();
    state.list = products.reduce((accumulator, product) => {
      if (!providerSet.has(product.institution.slug)) {
        providerSet.add(product.institution.slug, product.institution);
        accumulator.push(product.institution);
      }
      return accumulator;
    }, []).slice().sort((a, b) => a.name.localeCompare(b.name));
  },
  setMeta (state, meta) {
    state.meta = meta;
  }
};

export const getters = {
  get (state) {
    return state.current;
  },
  getList (state) {
    return state.list;
  },
  getMeta (state) {
    return state.meta;
  }
};
